
import service from '@/utils/request';

// 查询供应商列表  0未审核，1合格供应商，2潜在供应商，3不合格供应商
export function gysBasicInfoList(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysBasicInfo/gysBasicInfoList',
        data: param
    })
}

// 查询供应商分类 分页
export function gysClassifyList(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysClassify/gysClassifyList',
        data: param
    })
}

// 查询供应商分类 不分页
export function gysClassifyListAll(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysClassify/list',
        data: param
    })
}


// 根据父Id或取子分类
export function queryByParentId(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysClassify/queryByParentId',
        data: param
    })
}

// 编辑分类
export function classEdit(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysClassify/edit',
        data: param
    })
}
// 新增分类
export function classAdd(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysClassify/add',
        data: param
    })
}

// 删除供应商分类
export function delGysClassify(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysClassify/del',
        data: param
    })
}

// 审核供应商
export function auditBasicInfo(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysAuditRecord/passOrReject',
        data: param
    })
}
export function getGysAuditRecordList(param) {
    return service.request({
        method: 'POST',
        url: '/app/gysAuditRecord/gysAuditRecordList',
        data: param
    })
}
// export function gysAuditRecordList(param) {
//     return service.request({
//         method: 'POST',
//         url: '/app/gysAuditRecord/gysAuditRecordList',
//         data: param
//     })
// }



